import { DynamicRegulation } from "./Compliance/DynamicRegulation";

export interface UserCapabilities {
    apiAccessEnabled: boolean;
    auditLoggingEnabled: boolean;
    bomPermissionsEnabled: boolean;
    bulkEditSummaryDataEnabled: boolean;
    canCompareInventories: boolean;
    canExportOverallRating: boolean;
    canExportStandardReports: boolean;
    canPublishConsultantInventoryToClients: boolean;
    consultantAccountEnabled: boolean;
    consultantAccountNumberOfClients: boolean;
    declareAdministrationEnabled: boolean;
    enterpriseSurveysEnabled: boolean;
    exportDataEnabled: boolean;
    fileQuotaInMb: number;
    googleFeaturesEnabled: boolean;
    hniEdsReportEnabled: boolean;
    ilfiMemberEnabled: boolean;
    lifecycleStatusEnabled: boolean;
    maxLibraryInventories: number;
    maxSdsImportsPerYear: number;
    maxSuppliers: number;
    maxSurveyResponsesPerYear: number;
    mechoReportEnabled: boolean;
    myCustomersEnabled: boolean;
    myGreenLabBackendEnabled: boolean;
    newsEnabled: boolean;
    regulationsEnabled: boolean;
    obtainmentReportsEnabled: boolean;
    numTeamMembers: number;
    portfolioEnabled: boolean;
    privateListsEnabled: boolean;
    productComplianceEnabled: boolean;
    scipSubmissionEnabled: boolean;
    searchSdsLibraryEnabled: boolean;
    sendSurveysInBulkEnabled: boolean;
    submissionPlatformPartnerEnabled: boolean;
    substanceDatabaseChangeNotificationsEnabled: boolean;
    tasksEnabled: boolean;
    teamEnabled: boolean;
    teknionEdsReportEnabled: boolean;
    testReportsEnabled: boolean;
    versionControlEnabled: boolean;
    obtainmentServicesEnabled: boolean;
    autoAcceptSurveyEnabled: boolean;
    exportToOfflineSurveyEnabled: boolean;
}

export interface AvailableTeam {
    teamOwnerId: string;
    isActive: boolean;
    teamName: string;
}

export interface SubscriptionProduct {
    productName: string;
    priceName: string;
    stripeProductId: string;
    stripePriceId: string;
    quantity: number;
}

export interface Subscription {
    baseSubscriptionProduct: SubscriptionProduct;
}

export enum TeamRole {
    Owner = "Owner",
    Editor = "Editor",
    Viewer = "Viewer",
    IlfiPartner = "IlfiPartner",
    Admin = "Admin",
    Marketing = "Marketing"
}

export interface ReportTypesAndRegulationsBundle {
    allowedReportTypesForUser: string[];
    dynRegsForUser: DynamicRegulation[];
    reportTypeToRegulations: { [reportType: string]: string[] };
}

// todo: long term, consolidate "isEditor, isEditorOrMarketingRole" to a method that just looks at role itself.

export interface UserContext {
    //subscriptionName: string;
    //shouldConnectIlfiMembership: boolean;
    //hasIncompleteResponses: boolean;
    //numIncompleteSetupItems: number;
    //inAppMode: boolean;
    //aspNetControllerName: string;
    //aspNetActionName: string;
    teamOwnerId: string;
    userId: string;
    emailAddress: string;
    aimsId?: string; // aims ID from the database
    fullName: string;
    cultureName: string; // ISO standard name, e.g. "en" or "en-US" or "sp"
    isEditor: boolean;
    isEditorOrMarketingRole: boolean;
    teamName: string;
    availableTeamsList: AvailableTeam[];
    userCapabilities: UserCapabilities;
    isToxnotAdminUser: boolean;
    isSubscriptionActive: boolean;
    subscription: Subscription;
    signUpDate: string | null; // ISO8601
    intercomUserHash: string;
    intercomIsDisabled: boolean;
    saintGobainLifeSciencesFeatureEnabled: boolean;
    reportTypesAndRegulations: ReportTypesAndRegulationsBundle;
    hasSurveyResponseNotifications: boolean;
    isFre: boolean;
    role: TeamRole;
    averyDennisonFeaturesEnabled: boolean;
}
